/*eslint-disable no-unused-vars */
/*eslint-disable no-use-before-define */
import React, { forwardRef } from 'react';
import './GenericButton.scss';

const GenericButton = forwardRef((props, ref) => {
  const {
    children,
    variant = 'primary',
    className: cssClass,
    preLabel = 'preLabel',
    postLabel = children,
    disable = false,
    buttonDisabled = false,
    type = 'button',
    ariaLabel = '',
    tabIndex = 0,
    ...restProps
  } = props;

  let className =
    variant === 'secondary'
      ? 'secondary-button'
      : variant === 'link'
      ? 'link-button'
      : '';

  if (disable) {
    className += ' disabled-button';
  }
  if (cssClass) {
    className += ` ${cssClass}`;
  }

  return (
    <button
      type={type}
      className={
        disable && !buttonDisabled
          ? className
            ? `generic-primary-btn ${className} button--loading btn-disable-padding`
            : 'generic-primary-btn button--loading btn-disable-padding'
          : className
          ? `generic-primary-btn ${className}`
          : 'generic-primary-btn'
      }
      disabled={disable}
      aria-label={ariaLabel}
      onClick={props.onClick}
      tabIndex={tabIndex}
      ref={ref}
    >
      {!disable || buttonDisabled ? (
        <span className="btn-label">{children ? children : preLabel}</span>
      ) : (
        <span className="btn-label">{postLabel}</span>
      )}
    </button>
  );
});

export default GenericButton;
